import styles from "./Intro.module.css";

const Intro = (props) => {
  return (
    <div className={styles["description"]}>
      <p className={styles["intro"]}>
        Hello there!
        <br />
        My name is Harsh and I'm an{" "}
        <span className={styles["highlighted"]}>IT undergraduate</span>.
      </p>
      <p className={styles["summary"]}>
        My name is Harsh Gyanchandani, I live in Bhopal, India. I'm a pre-final
        year student at{" "}
        <span className={styles["highlighted"]}>
          Motilal Nehru National Institute of Technology Allahabad, Prayagraj
        </span>
        . I am passionate about problem solving and building cool stuff with
        technology. Currently exploring Machine Learning to add automation to my
        lazy life and Extended Reality to satisfy my curious mind.
        <br />
        <br />
        PS: I love photography and music :)
      </p>
    </div>
  );
};

export default Intro;
